/*
 * Algolia Utility functions
 *
 * This script should be CENTER PLACE of defining
 * all custom logic related to Algolia Search like,
 * excluding 'COLOR BLOCK' and 'COLOR BLANKET',
 * Non-Collaborations in Collaboration value.
 **/

import { MUAPP } from 'account/api';
import { logoutHandler, logoutEventHandler } from 'account/auth';
import { getTemplateName, getOrderId } from 'account/utils';
import { customerRenderHandler } from 'account/customer';
import {
  switchOrderTemplate,
  orderHistoryHandler,
  orderDetailHandler,
} from 'account/order';
import { returnRenderHandler } from 'account/returns';

/**
 * viewController
 * After authentication, call Customers & Order API to store in state
 *
 * @function
 * @param {object} orders - spars order data
 */
const viewController = () => {
  const template = getTemplateName();
  const orderId = getOrderId();
  const isNetsuite = window.LoloiConfig.erp_source == 'NETSUITE';

  // Account - Main
  if (!template && !orderId) {
    customerRenderHandler();
  }
  // Order History
  else if (template == 'order-history' && !orderId && !isNetsuite) {
    switchOrderTemplate();
    orderHistoryHandler();
  }
  // Order Detail
  else if (template == 'order-history' && orderId && !isNetsuite) {
    switchOrderTemplate(orderId);
    orderDetailHandler(orderId);
  }
  // Return && Return Confirm
  else if (template == 'return' || template == 'return-confirm') {
    returnRenderHandler(orderId);
  }
  // // Return Confirm
  // else if (template == "return-confirm") {
  //   // displayOrderId(orderId);
  // }
};

/**
 * Initialize
 *
 */
export const init = () => {
  if (
    window.location.pathname === '/account/login' &&
    MUAPP.cookies &&
    MUAPP.cookies.getCookie('accessKey')
  ) {
    logoutHandler();
  }
  if (window.LoloiConfig.customer_id) logoutEventHandler();

  return document.querySelector('.js-mu-app') &&
    MUAPP.cookies &&
    MUAPP.cookies.getCookie('accessKey')
    ? viewController()
    : false;
};



// WEBPACK FOOTER //
// ./src/scripts/src/account/index.js